<template>
  <v-container
    class="development-section"
    flex
  >

    <h1>
      <i class="fas fa-cog fa-lg fa-spin mr-3"></i>
      <span>Section in development</span>
    </h1>
  </v-container>
</template>

<script>
  export default {
    name: 'DevelopmentSection'
  }
</script>

<style scoped>
  .development-section {
    min-height: calc(100vh - 200px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
</style>
